import { SET_TOUR_VISIBILITY } from "../actions/tour";

const defaultState = {
    tourVisible: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_TOUR_VISIBILITY:
      return Object.assign({}, state, {
        tourVisible: action.tourVisible,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/tour.js